import { render, staticRenderFns } from "./taxData.vue?vue&type=template&id=bc39c7dc"
import script from "./taxData.vue?vue&type=script&lang=js"
export * from "./taxData.vue?vue&type=script&lang=js"
import style0 from "./taxData.vue?vue&type=style&index=0&id=bc39c7dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports